module.exports = __webpack_public_path__ + "static/img/qr-pub.faeb33ae.jpg";